import { useCalendar } from "./useCalendar";
import { CalendarValueType, CalendarMultipleValueType } from "../types";
import { useHookSubscribe } from "../../../hooks/hookSubscribe";

export function useCalendarValue(): [CalendarValueType | CalendarMultipleValueType, (val: CalendarValueType | CalendarMultipleValueType) => void ] {
  const context = useCalendar();
  const value = useHookSubscribe(context.currentValue, context.value);
  const setContextValue = (val: CalendarValueType | CalendarMultipleValueType) => {
    context.setValue(val);
  }
  return [value, setContextValue];
}
